import React from "react";
import "../css/home.css";
import Dashboard from "../pages/Dashboard";
import FinHistory from "./FinHistory";
import FinSummary from "./FinSummary";
import FinTracker from "./FinTracker";
import Preference from "./Preference";
import SearchBox from "./SearchBox";
const Home = () => {
  return (
    <Dashboard>
      <section className="home outlet">
        <div className="home-top">
          <SearchBox />
          <Preference />
        </div>
        <h2 className="outlet-title">Patient Dashboard</h2>
        <div className="section-1">
          <div>
            <FinSummary />
            <FinTracker />
          </div>
          <FinHistory />
        </div>
      </section>
    </Dashboard>
  );
};

export default Home;
